"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_2 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_3 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_4 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_5 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_6 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_7 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
let GISLifeCycleItem = class GISLifeCycleItem extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.mixpanelHandler = new MixpanelHandler_1.default();
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get showDeleteButton() {
        return this.isFinishedStatus(this.status)
            && (!this.isFinishedStatus(this.sampleCollectingStatus) || (this.isFinishedStatus(this.sampleCollectingStatus) && this.isBMK))
            && !this.isFinishedStatus(this.resultStatus);
    }
    isFinishedStatus(status) {
        return !(status === 'pending' || status === 'error' || status === 'waiting');
    }
    mainActionCliked() {
        this.mixpanelHandler.trackEvent('mainActionInProposalStage', {
            'stage': 'gis_file_upload',
            'type': 'user',
            'status': this.status
        });
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'pending' })
], GISLifeCycleItem.prototype, "status", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'pending' })
], GISLifeCycleItem.prototype, "resultStatus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'pending' })
], GISLifeCycleItem.prototype, "sampleCollectingStatus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], GISLifeCycleItem.prototype, "isBMK", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], GISLifeCycleItem.prototype, "theme", void 0);
GISLifeCycleItem = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            LifeCycleTemplate: bmk_ui_framework_7.LifeCycleTemplate,
            GISIcon: bmk_ui_framework_1.GISIcon,
            Loader: bmk_ui_framework_4.Loader,
            TubeIcon: bmk_ui_framework_3.TubeIcon,
            ShipmentIcon: bmk_ui_framework_5.ShipmentIcon,
            LoaderLabPhases: bmk_ui_framework_6.LoaderLabPhases,
            PlusCircle: lucide_vue_next_1.PlusCircle,
            MapPin: lucide_vue_next_1.MapPin,
            HelpCircle: lucide_vue_next_1.HelpCircle,
            DownloadCloud: lucide_vue_next_1.DownloadCloud,
            ArrowUpRight: lucide_vue_next_1.ArrowUpRight,
            GitFork: lucide_vue_next_1.GitFork,
            ArrowRight: lucide_vue_next_1.ArrowRight,
            List: lucide_vue_next_1.List,
            GuideIcon: bmk_ui_framework_2.GuideIcon,
            Trash2: lucide_vue_next_1.Trash2,
        },
    })
], GISLifeCycleItem);
exports.default = GISLifeCycleItem;
